import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { isMobile } from 'react-device-detect';
import { useUserProfile } from '../../contexts/UserProfileContext';
import { useNavigate } from 'react-router-dom';

// is-mobile

export const Topbar = (props: any) => {
  const { instance, accounts } = useMsal();
  const { profile, loading } = useUserProfile();
  const navigate = useNavigate();
  useEffect(() => {
    if (isMobile) {
      navigate('/desktop-olny');
    }
  }, []);

  return (
    <div className="admin-top-bar">
      <div className="row">
        <div className="col-12 col-sm-7 col-md-7"></div>
        <div className="col-12 col-sm-5 col-md-5">
          <div className="user-profile d-flex float-end">
            <div className="text-end me-2 pt-1">
              <label>{profile?.employeeNameEn}</label>
              <p>Admin</p>
            </div>
            <div>
              <img src="../../../images/user.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
